import { render, staticRenderFns } from "./AuthSecond.vue?vue&type=template&id=16a6a967&scoped=true&"
import script from "./AuthSecond.vue?vue&type=script&lang=ts&"
export * from "./AuthSecond.vue?vue&type=script&lang=ts&"
import style0 from "./AuthSecond.vue?vue&type=style&index=0&id=16a6a967&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a6a967",
  null
  
)

export default component.exports